module.exports = __webpack_public_path__ + "static/media/swimming.d35ed0fa.svg";